import React from 'react';
import { useTranslation } from 'react-i18next';
import { devApiInstance as request } from '@/services/request/client';

export interface NoteArticleAPIResponse {
  title: string;
  key: string;
}

const useNoteArticleData = () => {
  const { i18n } = useTranslation();
  const [articles, setArticles] = React.useState<NoteArticleAPIResponse[]>([]);

  const fetch = async () => {
    try {
      const res = await request.get(`/note/article?lang=${i18n.language}`);
      setArticles(res.data.articles);
    } catch (e) {
      console.error(e);
      setArticles([]);
    }
  };

  React.useEffect(() => {
    fetch();
  }, [i18n.language]);

  return articles;
};

export default useNoteArticleData;
